import { createSvgIcon } from './_base';

export const ChevronRightIcon = createSvgIcon(
  '0 0 24 24',
  <path d="M8.47 3.47a.75.75 0 0 1 1.06 0l8 8a.75.75 0 0 1 0 1.06l-8 8a.75.75 0 0 1-1.06-1.06L15.94 12 8.47 4.53a.75.75 0 0 1 0-1.06Z" />
);
